"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeNetStub = decodeNetStub;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const decode_prop_block_1 = require("./decode-prop-block");
const entity_list_1 = require("./entity-list");
const decode_tc8_wire_bundle_1 = require("./decode-tc8-wire-bundle");
const typeCodes_1 = require("../typeCodes");
function decodeNetStub(node, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:5 (NetStub), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const c = node.children;
    if (c.length !== 7) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `tc:5 (NetStub) has ${c.length} children, expected 7`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const stubIdAtom = c[2];
    const stubId = stubIdAtom.type === 'atom' ? stubIdAtom.content.trim() : null;
    const props = (0, decode_prop_block_1.decodePropBlock)(c[6], `${path}/props`, warnings);
    const isDefault = (0, decode_prop_block_1.findPropValue)(props, 'name') === 'default';
    const wireBundles = (0, entity_list_1.isPlaceholderContainer)(c[0]) ? null : (((0, entity_list_1.decodeEntityList)(c[0], typeCodes_1.TypeCode.WireBundle, `${path}/wireBundles`, warnings, (item, _i, itemPath) => (0, decode_tc8_wire_bundle_1.decodeWireBundle)(item, itemPath, warnings)) ?? c[0]));
    return {
        kind: 'net-stub',
        stubId,
        wireBundles,
        props,
        isDefault,
        raw: node,
    };
}
//# sourceMappingURL=decode-tc5.js.map